import { Inject, Injectable } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthServiceInterface } from '@freelancer/auth/interface';
import { Facebook } from '@freelancer/facebook';
import { Location } from '@freelancer/location';
import { Observable, switchMap } from 'rxjs';
import { LOGIN_AUTH_SERVICE, LOGIN_CONFIG } from './login.config';
import { LoginConfig } from './login.interface';

/**
 * TODO: T280954 - Convert to functional guard.
 *
 * Currently, when converted, it throws no provider for Facebook service when logging
 * out in UI tests. Unsure why, but maybe somehow related to using inject() or the
 * logged-in/out shells.
 */
@Injectable({
  providedIn: 'root',
})
export class LogoutGuard {
  constructor(
    private location: Location,
    @Inject(LOGIN_AUTH_SERVICE) private authService: AuthServiceInterface,
    @Inject(LOGIN_CONFIG) private loginConfig: LoginConfig,
    private facebook: Facebook,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<UrlTree> {
    return this.authService.isLoggedIn().pipe(
      switchMap(async isLoggedIn => {
        const { next } = route.queryParams;

        if (isLoggedIn) {
          await this.authService.logout();
          await this.facebook.logout();
        }

        return this.location.createUrlTree(
          [next || this.loginConfig.defaultLogoutRedirectUrl],
          { initialStateIsPrimary: true },
        );
      }),
    );
  }
}
